<template>
  <div id="slider">
    <div class="flexslider">
      <div class="flex-viewport">
        <div class="slider-wrap">
          <vueper-slides
            ref="slides"
            autoplay
            :transitionSpeed="550"
            fixed-height="500px"
            :speed="5000"
            :arrows="false"
            :bullets="false">
            <vueper-slide>
              <div slot="slideContent">
                <img src="../assets/imgs/home-carousel/AppsyPretty1-1040x500.jpg" alt="Appsy 1" />
                <div class="slide-caption">
                  Com o aplicativo Appsy para smartphones Android e iPhones, você tem acesso à "Timeline" de seus pacientes em qualquer lugar, podendo acompanhar de perto a evolução do quadro.
                </div>
              </div>
            </vueper-slide>
            <vueper-slide>
              <div slot="slideContent">
                <img src="../assets/imgs/home-carousel/AppsyPretty2-1040x500.jpg" alt="Appsy 2" />
                <div class="slide-caption">
                  O Appsy suporta o trabalho conjunto, com diferentes papéis, do grupo de assistentes, auxiliares e residentes de um psiquiatra.
                </div>
              </div>
            </vueper-slide>
            <vueper-slide>
              <div slot="slideContent">
                <img src="../assets/imgs/home-carousel/editada-31-1040x500.jpg" alt="Appsy 3" />
                <div class="slide-caption">
                  A timeline e o canal de mensagens permitem ao Psiquiatra dar um tratamento muito especial a seus pacientes, aumentando a aderência ao tratamento.
                </div>
              </div>
            </vueper-slide>
          </vueper-slides>
        </div>
      </div>
      <ul class="flex-direction-nav">
        <li><a class="flex-prev" @click.prevent="$refs.slides.prev()">Previous</a></li>
        <li><a class="flex-next" @click.prevent="$refs.slides.next()">Next</a></li>
      </ul>
    </div>
    <div class="slider-border"></div>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'

export default {
  metaInfo: {
    title: 'Appsy - Ferramenta para a prática diária do psiquiatra',
    titleTemplate: null,
  },

  components: {
    VueperSlides,
    VueperSlide,
  },
};
</script>
